import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

// Component
import Link from '../Link';

// Locale
import messages from '../../locale/jsonMessages';

// Image
import arrow from '/public/siteImages/rightSideArrow.svg';

import cs from '../../components/commonStyle.css';
import s from './VerifiedInfo.css';

const NoItem = ({ isLoggedInUser, isTrustVerfiedPage }) => (
    <>
        <h5 className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom3)}>
            <FormattedMessage {...messages.noVerifications} />
        </h5>
        {isLoggedInUser && !isTrustVerfiedPage && (
            <Link
                to="/user/verification"
                className={cx(
                    cs.commonContentText,
                    cs.siteLinkColor,
                    cs.fontWeightMedium,
                    cs.commonLinkBorderBottom,
                    cs.textDecorationNone
                )}
            >
                <FormattedMessage {...messages.addVerifications} />
                <img src={arrow} className={cx(cs.blueLeftArrow, 'loginArrowRTL')} alt="arrow" />
            </Link>
        )}
    </>
);

NoItem.propTypes = {
    isLoggedInUser: PropTypes.bool.isRequired,
    isTrustVerfiedPage: PropTypes.bool,
};

export default injectIntl(withStyles(cs, s)(NoItem));